import { jsx as _jsx } from "react/jsx-runtime";
import './style.css';
const VnTooltip = ({ content }) => {
    return (_jsx("div", { className: 'vn-tooltip position-relative', children: _jsx("div", { className: 'vn-tooltip-content position-absolute', children: content }) }));
};
export default VnTooltip;
